import React from 'react';

import RIQDropdown from '../../../components/RIQDropdown.jsx';

import useListeningCurationFilterValues from '../hooks/useListeningCurationFilterValues.js';

import {
    useCurationConfigState,
    useCurationConfigValue
} from '../../../hooks/widgetConfiguration.js';

import {
    useGetDashboardType
} from '../hooks/useGetDashboardType.js';

export function useIntervalOptions() {
    const interval = useCurationConfigValue('graphInterval');
    const metricFilters = useListeningCurationFilterValues();
    const dashboardType = useGetDashboardType();

    let intervalOptions = RivalIQ.enums.timePeriod.intervalDropdownOptions(metricFilters.timePeriod.startDate, metricFilters.timePeriod.endDate);

    // For now, we're going to remove "Auto" from the dropdown
    // For now, in companion mode, we want to show month, but for listening, because we only have 30 days available,
    // it does not make sense to have a monthly option
    intervalOptions = _.filter(intervalOptions, (option) => {
        if (dashboardType === 'topic') {
            return option.id !== 'auto';
        }
        return option.id !== 'auto' && option.id !== RivalIQ.enums.timePeriod.interval.monthly;
    });

    const selectedInterval = _.find(intervalOptions, {
        id: interval
    });
    selectedInterval.selected = true;

    return {
        intervalOptions,
        selectedInterval
    };
}


export function IntervalSelector() {

    const setInterval = useCurationConfigState('graphInterval')[1];
    const {intervalOptions, selectedInterval} = useIntervalOptions();

    return (
        <div>
            <span className='tlw-text-sm'>Grouped by:&nbsp;</span>
            <RIQDropdown
                variant='small'
                title={selectedInterval.name}
                dropdownOptions={intervalOptions}
                onItemSelected={(selectedOption) => setInterval(selectedOption.id)}
            />
        </div>
    );
}
